import { render } from "./ImageAnsweringView.vue?vue&type=template&id=f40f17d0&scoped=true"
import script from "./ImageAnsweringView.vue?vue&type=script&lang=js"
export * from "./ImageAnsweringView.vue?vue&type=script&lang=js"

import "./ImageAnsweringView.vue?vue&type=style&index=0&id=f40f17d0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f40f17d0"]])

export default __exports__